import SharedProcessingTimeSection, { type ProcessingOption } from "@/components/feature/SharedProcessingTimeSection";

const options: ProcessingOption[] = [
  {
    speed: "2–9",
    unit: "Business Days",
    label: "Fast Passport Center",
    tag: "Most Popular",
    tagColor: "bg-[#F6C344] text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission — no drive to New Orleans or Atlanta needed",
      "Ideal for NAS Meridian military with PCS and deployment orders",
      "Perfect for MSU-Meridian students with study abroad deadlines",
      "Great for East Mississippi business travelers flying via Meridian Regional",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: true,
  },
  {
    speed: "3–5",
    unit: "Weeks",
    label: "Fast Passport Center",
    tag: "Standard Expedited",
    tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Faster than self-service at Meridian post offices",
      "Good for planned international trips from East Mississippi",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: false,
    smartSaver: true,
  },
  {
    speed: "1–2",
    unit: "Months",
    label: "Self-Service (Post Office)",
    tag: "Slowest",
    tagColor: "bg-gray-100 text-gray-400",
    features: [
      "No courier access — standard mail only",
      "No document review — errors cause rejection",
      "In-person clerk appointment required at Meridian or Quitman USPS",
      "Workload shifts with government shutdowns and budget fights",
      "No dedicated agent — you are on your own",
      "Updates only by physical mail letter",
      "No phone or email contact for your case",
      "Cannot upgrade speed after submission",
      "Not suitable if travel is within 10 weeks",
    ],
    highlight: false,
    muted: true,
  },
  {
    speed: "24",
    unit: "Hours*",
    label: "Regional Agency Processing",
    tag: "Emergency Only",
    tagColor: "bg-gray-100 text-gray-500",
    features: [
      "Closest regional agencies: New Orleans (~3 hrs SW) or Atlanta (~3.5 hrs east)",
      "NPIC appointment required before traveling to either agency",
      "Life-or-death emergencies only",
      "Bereavement or medical crisis documentation required",
      "Expect to wait all day or return next day",
    ],
    highlight: false,
    emergency: true,
  },
];

export default function MeridianProcessingTimeSection() {
  return (
    <SharedProcessingTimeSection
      cityName="Meridian, MS"
      introText="Meridian travelers — Naval Air Station Meridian service members with PCS orders to Japan and Korea, MSU-Meridian students with study abroad acceptances, East Mississippi business travelers flying through Meridian Regional Airport, and Lauderdale County families planning international vacations — have several options for getting a passport fast. Here is how they compare, and why most East Mississippi residents choose a U.S. Department of State registered passport courier for predictable, professional processing without the drive to New Orleans or Atlanta."
      options={options}
      emergencyDescription="Meridian does not have its own regional passport agency. The closest are New Orleans (~3 hrs southwest via I-59) and Atlanta (~3.5 hrs east via I-20). For NAS Meridian personnel with deployment orders or life-or-death family emergencies, call NPIC at 1-877-487-2778 to book an appointment. No walk-ins accepted."
      disclaimerText="*Processing speed depends on eligibility and documentation. Meridian does not have a regional passport agency — the closest is New Orleans or Atlanta. Not all applicants qualify for Regional Agency Processing."
    />
  );
}